import React from 'react';
import { Clock } from 'lucide-react';

const getRemaining = (validUntil) => {
  const end = new Date(`${validUntil}T23:59:59`);
  const ms = end - new Date();
  if (ms <= 0) return null;
  return { d: Math.floor(ms / 86400000), h: Math.floor((ms % 86400000) / 3600000), m: Math.floor((ms % 3600000) / 60000) };
};

export const formatEndDate = (validUntil) =>
  new Date(`${validUntil}T12:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

export const OfferCountdown = ({ validUntil, className = '', testId }) => {
  const [left, setLeft] = React.useState(() => getRemaining(validUntil));

  React.useEffect(() => {
    const t = setInterval(() => setLeft(getRemaining(validUntil)), 60000);
    return () => clearInterval(t);
  }, [validUntil]);

  const shortEnd = new Date(`${validUntil}T12:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  return (
    <div className={`inline-flex items-center gap-2 bg-slate-900/85 backdrop-blur-md text-white rounded-full pl-3 pr-1 py-1 text-xs font-semibold ${className}`} data-testid={testId}>
      {left ? <span>Ends {shortEnd}</span> : <span className="bg-orange-500 rounded-full px-2 py-0.5 -ml-2">Offer ended</span>}
      {left && (
        <span className="inline-flex items-center gap-1 bg-emerald-500 rounded-full px-2 py-0.5 tabular-nums">
          <Clock size={11} /> {left.d}d {left.h}h {left.d === 0 ? `${left.m}m ` : ''}left
        </span>
      )}
    </div>
  );
};
